import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query/react';

import { rapidstorApi } from '../features/rapidstor/rapidstorApiSlice';

import { bookingSlice } from './bookingSlice';

const reducer = combineReducers({
    [rapidstorApi.reducerPath]: rapidstorApi.reducer,
    [bookingSlice.name]: bookingSlice.reducer,
});

const store = configureStore({
    reducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(rapidstorApi.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
